/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from '@rails/ujs';
Rails.start();
// require('jquery-ujs'); // Commented out or removed
require('turbolinks').start();
require('@rails/activestorage').start();
require('channels');
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


require('trix');
require('@rails/actiontext');

// Configure Trix for Active Storage Direct Uploads
import '../trix_direct_upload.js'

import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

const application = Application.start()
const context = require.context("../controllers", true, /\.js$/)
application.load(definitionsFromContext(context))

// Import FullCalendar v6
import '../calendar_v6.js'

// Import Tom Select for Reports Equipment & Method Specific Variables tabs
import './tom-select-init.js'
